import { gsap } from 'gsap';

function fullscreenImageSetup(el) {
  const img = el.querySelector('img');
  gsap.set(img, { scale: 1.2 });
  gsap.set(el, { autoAlpha: 0 });
}

function fullscreenImageEnter(el) {
  const img = el.querySelector('img');

  const tl = gsap.timeline({ defaults: { duration: 1.2, ease: 'power2.out' }});
  tl.to(el, { autoAlpha: 1 }, 0);
  tl.to(img, { scale: 1 }, 0);
}

export { fullscreenImageSetup, fullscreenImageEnter };